import { FC } from "react"
import { TimezoneSuccess } from "../../../../module/settings/containers/timezone/success"

export const TimezoneSuccessPage: FC = () => <TimezoneSuccess />
